// TODO: Convert dashboard.html to this component
// Use: useQuery with getRecordings from roomService

export default function DashboardPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-4xl">
        <div className="bg-white shadow-lg border border-gray-200 rounded-lg p-8 text-center">
          <h1 className="text-3xl font-bold mb-4 text-gray-800">📊 Dashboard</h1>
          <p className="text-gray-600 mb-6">
            View all interviews and recordings
          </p>
          <div className="text-sm text-gray-500">
            Dashboard functionality coming soon...
          </div>
        </div>
      </div>
    </div>
  )
}
